<div [formGroup]="formGrp">
  <div>
    <input (keyup.enter)="sendInput($event)" [formControlName]="formCtrlName" form type="text"
      class="form-control form-input" [placeholder]="placeholder">
    <!-- <fa-icon *ngIf="showPrefixIcon" class="prefix" [icon]="icons.marker"></fa-icon> -->
  </div>

</div>
